import React from 'react';
import './styles.css';
const CheckAnimate = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="container">
    <g
      id="paiement-à-table---Ecran-0-Copy-4"
      transform="translate(-128.000000, -252.000000)"
      fillRule="nonzero"
    >
      <g id="checked" transform="translate(128.000000, 252.000000)">
        <path
          d="M117.670414,16.3387256 C115.893194,14.5565572 113.009576,14.5534865 111.232356,16.3311671 L56.6102064,70.8667027 L36.902694,49.4398178 C35.1997999,47.589386 32.3206655,47.4693938 30.4691192,49.1738507 C28.6189886,50.8785439 28.5005387,53.7621373 30.2034328,55.6142225 L53.1208899,80.5293862 C53.9601852,81.4425557 55.1347739,81.9728364 56.3733066,81.9985828 C56.4065764,82 56.4386664,82 56.4705205,82 C57.6741318,82 58.8319676,81.5214482 59.6849483,80.670637 L117.661448,22.7850025 C119.443151,21.0075582 119.446218,18.1208941 117.670414,16.3387256 Z"
          id="Path"
          className="checkmark__check"
        ></path>
        <path
          className="checkmark__circle"
          d="M116.439576,55.9395762 C113.920791,55.9395762 111.879389,57.9809785 111.879389,60.5 C111.879389,88.8317246 88.8317246,111.879389 60.5,111.879389 C32.1699297,111.879389 9.12061133,88.8317246 9.12061133,60.5 C9.12061133,32.1699297 32.1699297,9.12061133 60.5,9.12061133 C63.0187852,9.12061133 65.0604238,7.07920898 65.0604238,4.56042383 C65.0604238,2.04140234 63.0187852,0 60.5,0 C27.1399219,0 0,27.1399219 0,60.5 C0,93.8586602 27.1399219,121 60.5,121 C93.8586602,121 121,93.8586602 121,60.5 C121,57.9812148 118.958598,55.9395762 116.439576,55.9395762 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);

export default CheckAnimate;
